import { render, staticRenderFns } from "./table-empty.vue?vue&type=template&id=71d74b06&scoped=true"
import script from "./table-empty.vue?vue&type=script&lang=ts"
export * from "./table-empty.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d74b06",
  null
  
)

export default component.exports